export default "__VITE_ASSET__BW1TKX46__"